import { LANGUAGES } from '../../constants/Languages';
import BaseEntity from './BaseEntity';
import CommitSimple from './CommitSimple';
const LANGUAGES_IN_BREAKDOWN = 11; // 10 + other
const DEFAULT_COLOR = '#336fa2';
const DEFAULT_OTHER_COLOR = '#f3f3f3';
export default class CommitList extends BaseEntity {
    constructor(commitList, limit, moreCommits, currentPage, defects, codeCoverage) {
        super();
        this.commits = [];
        this.currentPage = 1;
        this.limit = limit;
        this.moreCommits = moreCommits;
        this.currentPage = currentPage;
        this.defects = defects;
        if (commitList.length) {
            this.commits = commitList.map((commit) => new CommitSimple(commit, defects, codeCoverage && typeof commit.id === 'number' && commit.id in codeCoverage.commits ? codeCoverage.commits[commit.id] : undefined));
        }
    }
    getDefectListForCommit(commitHash) {
        const commit = this.commits.find(({ hash }) => hash === commitHash);
        if (commit) {
            if (!commit.defectList.defects.length) {
                throw new Error(`Commit (${commitHash}) has no defects.`);
            }
            return commit.defectList;
        }
        throw new Error(`Commit (${commitHash}) not found.`);
    }
    hasTooBigDefect() {
        // @ts-expect-error Property 'name' does not exist on type '{}'.
        return !!Object.values(this.defects).find((defect) => defect?.name === 'TooBigRepository');
    }
    getLanguageBreakdown(lastCommit, getLangPercent) {
        const allLanguages = [];
        this.commits.forEach((commit) => Object.values(commit.languages ? commit.languages.languages : {}).map((lang) => allLanguages.push(lang.name)));
        const allLanguagesFiltered = allLanguages.filter((language, index, languages) => languages.indexOf(language) === index);
        const fileStats = lastCommit.languages;
        let langArray = allLanguagesFiltered
            .map((lang) => ({
            name: lang,
            percent: getLangPercent(fileStats, lang),
            color: (LANGUAGES[lang] && LANGUAGES[lang].color) || DEFAULT_COLOR,
        }))
            .sort((first, second) => second.percent - first.percent);
        const displayedLangs = langArray.slice(0, LANGUAGES_IN_BREAKDOWN);
        const otherPlaceholder = {
            name: 'Other',
            percent: Number((100 - displayedLangs.reduce((acc, lang) => acc + lang.percent, 0)).toFixed(2)),
            color: DEFAULT_OTHER_COLOR,
        };
        langArray = [...langArray, otherPlaceholder].sort((first, second) => second.percent - first.percent);
        return {
            langArray,
            displayedLangs,
            otherPlaceholder,
        };
    }
    getCommitsPercentage() {
        const commitsPercentage = {};
        for (const commit of this.commits) {
            commitsPercentage[commit.id] = commit.getAnalysisPercentage();
        }
        return commitsPercentage;
    }
    hasAnyRunningAnalysis() {
        for (const commit of this.commits) {
            if (commit.isAnalysisStillRunning()) {
                return true;
            }
        }
        return false;
    }
}
